
/**
 * 首页的装修项
 */
export default {
    base: [ //基础组件
        {
            type: 'poster_bgimg',
            name: '背景图片',
        }, {
            type: 'poster_goodimg',
            name: '商品图片',
            icon: 'ivu-icon ivu-icon-ios-contract'
        }, {
            type: 'poster_goodname',
            name: '商品名称',
            svg: 'sousuo1'
        }, {
            type: 'poster_price',
            name: '商品会员价',
            icon: 'iconfont icon-haibao-huiyuanjia'
        },
        {
            type: 'poster_delprice',
            name: '商品划线价',
        }, {
            type: 'poster_sellprice',
            name: '商品售卖价',
            icon: 'iconfont icon-haibao-xianjia'
        }, {
            type: 'poster_qrcode',
            name: '二维码',
        }, {
            type: 'poster_shoplogo',
            name: '店铺LOGO',
            icon: 'iconfont icon-haibao-logo'
        },
        {
            type: 'poster_shopname',
            name: '店铺名称',
            icon: 'iconfont icon-haibao-dianpumingcheng'
        },  {
            type: 'poster_avatar',
            name: '头像',
            icon: 'iconfont icon-shuju-huiyuanshu'
        },
        {
            type: 'poster_nickname',
            name: '昵称',
            icon: 'iconfont icon-haibao-yonghunicheng'
        }, {
            type: 'poster_img',
            name: '图片',
            icon: 'iconfont icon-datuzu'
        }, {
            type: 'poster_text',
            name: '文本',
            icon: 'iconfont icon-biaotilan'
        },
        {
            type: 'poster_commission',
            name: '分销佣金',
            icon: 'iconfont icon-chengweifenxiaoshangtongzhi'
        },
    ],
}